// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d0461ecd","977":"8232ae0a"}[chunkId] + ".chunk.js";
};